<script setup>
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'
import SiteDialogs from './components/SiteDialogs.vue'
</script>

<template>
  <a class="skip-link" href="#main">تجاوز إلى المحتوى</a>
  <SiteHeader />
  <RouterView />
  <SiteFooter />
  <SiteDialogs />
</template>
